module.exports = __webpack_public_path__ + "static/bannerObject1-7b4f73bff849e81f64abc3ef3ece17b7.png";